/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_PerInputs */

const en_admin_resources_per = /** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per`)
};

const de_admin_resources_per = /** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const es_admin_resources_per = /** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cada`)
};

const fr_admin_resources_per = /** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par`)
};

/** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */
const it_admin_resources_per = en_admin_resources_per;

/** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */
const pt_br2_admin_resources_per = en_admin_resources_per;

/** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */
const pl_admin_resources_per = en_admin_resources_per;

/** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */
const hu_admin_resources_per = en_admin_resources_per;

/** @type {(inputs: Admin_Resources_PerInputs) => LocalizedString} */
const ro_admin_resources_per = en_admin_resources_per;

/**
* | output |
* | --- |
* | "Per" |
*
* @param {Admin_Resources_PerInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_per = /** @type {((inputs?: Admin_Resources_PerInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_PerInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_per(inputs)
	if (locale === "de") return de_admin_resources_per(inputs)
	if (locale === "es") return es_admin_resources_per(inputs)
	if (locale === "fr") return fr_admin_resources_per(inputs)
	if (locale === "it") return it_admin_resources_per(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_per(inputs)
	if (locale === "pl") return pl_admin_resources_per(inputs)
	if (locale === "hu") return hu_admin_resources_per(inputs)
	return ro_admin_resources_per(inputs)
});
export { admin_resources_per as "admin.resources.per" }